<!-- El botón no reporta estado ni comunicación: sin resumen. Las alertas que
     disparó están en su pestaña. -->
<div class="ble-info">
  <app-dt-card titulo="Botón" icono="touch_app">
    <app-dt-datos>
      <app-dt-dato etiqueta="MAC" [valor]="botonBLE?.mac" mono copiable />
      <app-dt-dato
        etiqueta="Número de serie"
        [valor]="botonBLE?.serialNumber"
        mono
        copiable
      />
      <app-dt-dato etiqueta="Marca y modelo" [valor]="marcaModelo" />
      <app-dt-dato etiqueta="Fecha de creación" [valor]="fechaCreacion" />
    </app-dt-datos>
  </app-dt-card>
</div>
